// extracted by mini-css-extract-plugin
module.exports = {"slotsSection":"Slots_slotsSection__3Abmn","PlaceBidForm":"Slots_PlaceBidForm__38nxG","FinalizedDiv":"Slots_FinalizedDiv__3_lPf"};